export default __webpack_public_path__ + "static/media/workouts.38bba9a1.png";